import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_robotizz.png",
      alt: "Robotizz",
    },
    title: "Dê um Robotizz nos seus investimentos",

    // String ou array de strings
    text: "Na Robotizz Trader Solutions, acreditamos que o futuro do trade está na automação inteligente. Nossos robôs de daytrade são projetados para otimizar suas operações e potencializar seus lucros. Com tecnologias próprias de análise de mercado, nossas soluções automatizadas oferecem a precisão e a rapidez necessárias para você alcançar resultados consistentes. Experimente a eficiência de um trade automatizado e dê um Robotizz nos seus investimentos. ",
    testimonial: {
      text: "Criar o simples com as mais avançadas tecnologias!",
      author: {
        name: "Renato Takahashi, CEO Robotizz Trader Solutions",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Robotizz",
    heading: "A simplicidade e consistência que você precisa",
    subtitle: "Estratégias, prontas, simples e robustas que resultam em consistência e lucratividade na medida certa.",
  },

  cta: {
    title: "Não perca mais tempo!",
    subtitle: "Experimente nossos robôs de daytrade hoje mesmo e veja a diferença.",
    buttonText: "Ativar a Robotizz!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Robotizz",
    col1: [
      "A Robotizz Trader Solutions, fundada em 2020 por Renato Takahashi e Gabriel Rodrigues Dejavite, é uma empresa especializada no desenvolvimento de estratégias de trade e robôs automatizados para o mercado financeiro. Acreditamos firmemente no poder da automação inteligente para o futuro do trade. Nosso objetivo é revolucionar o mercado financeiro oferecendo soluções inovadoras que combinam tecnologia avançada com expertise em análise de mercado. ",
    ],
    col2: [
      "Com uma equipe dedicada de especialistas em tecnologia e estrategistas, estamos comprometidos em fornecer aos nossos clientes ferramentas poderosas para automatizar e otimizar suas operações de daytrade. Nossa missão é criar estratégias simples e consistentes que focam no que realmente importa: suas operações financeiras. Conte com a Robotizz para transformar sua abordagem de investimento, alcançando eficiência, consistência e sucesso em seus objetivos financeiros. ",
    ],
  },

  stats: {
    title: "Alguns números da Robotizz",
    subtitle: "Transformando estratégias em robôs",
    data: [
      {
        value: "+4",
        description: "Anos de atividade",
      },
      {
        value: "Top1",
        description: "do MQL5 nacional desde 2023",
      },
      {
        value: "Top100",
        description: "do MQL5 mundial",
      },
      {
        value: "+18",
        description: "Meses de operação sem mudança de parâmetros",
      },
    ],
  },

  // picture: {
  //   url: "https://ontick-img.s3.sa-east-1.amazonaws.com/nl_resultado.jpeg",
  //   description: "Algoritmo de Mini-índice x Ibovespa. Atualizado em 12 de setembro de 2022.",
  // },

  features: {
    title: "Por que utilizar os meus robôs?",
    subtitle: "Veja quais as principais vantagens.",
    data: [
      {
        icon: iconsSet.backtest,
        title: "Consistência",
        description:
          "Nossos robôs são projetados para seguir estratégias rigorosas e testadas, garantindo que suas operações sejam consistentes e livres de decisões impulsivas ou emocionais, resultando em um desempenho mais estável e previsível ao longo do tempo.",
      },
      {
        icon: iconsSet.balance,
        title: "Gerenciamento Eficiente",
        description:
          "Nossos robôs são projetados para realizar um gerenciamento completo das operações, controlando limites por operação, assim como ganhos e perdas diárias, maximizando lucratividade e evitando surpresas negativas. ",
      },
      {
        icon: iconsSet.yoga,
        title: "Maior Liberdade",
        description:
          "Com nossos robôs de daytrade, você automatiza suas operações e libera seu tempo para outras atividades importantes, permitindo que você aproveite ao máximo seu tempo livre enquanto seus investimentos continuam a crescer.",
      },
      {
        icon: iconsSet.paper_board,
        title: "Estratégias Simples",
        description:
          "Nossos robôs utilizam algoritmos que priorizam a generalização sobre o overfitting, ou seja, são projetados para não se ajustar excessivamente aos dados históricos, mas sim para identificar padrões robustos e aplicáveis em diferentes cenários de mercado. ",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Especializado",
        description:
          "Nossa equipe de suporte está sempre disponível para ajudar você a tirar o máximo proveito de nossas soluções. Oferecemos assistência técnica e orientação especializada para garantir que você utilize nossos robôs de forma eficaz e maximize seus resultados. ",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Influência Emocional ",
        description:
          "Um dos maiores desafios no daytrade é a influência das emoções. Nossos robôs operam com base em algoritmos predefinidos e estratégias testadas, eliminando o impacto das decisões emocionais e garantindo operações racionais e consistentes. ",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Os robôs da Robotizz geram lucros de forma impressionante, recuperando rapidamente qualquer perda. Está sendo minha primeira experiência no mercado financeiro, proporcionando grandes emoções. O suporte técnico é excelente, sempre esclarecendo todas as minhas dúvidas. Estou muito satisfeito!",
      author: "Fernando Nakamura Ono",
      job: "Técnico Mecatrônico",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Desde que comecei a usar os robôs da Robotizz, minha performance no mercado financeiro melhorou consideravelmente. Os robôs dão lucro e de forma consistente. Top demais! ",
      author: "Robinson José de Freitas",
      job: "Servidor Público Municipal",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Escolha o plano mais adequado para você:",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
